import { render, staticRenderFns } from "./goodParams.vue?vue&type=template&id=7d0f1892&"
import script from "./goodParams.vue?vue&type=script&lang=js&"
export * from "./goodParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports